






































import { BookCommentComponents } from '@/views/book/comment/components'
import { defineClassComponent } from '@/hooks'
import { jointGoodsModelProvider } from '../model'
import { navigateTo } from '@/router'

export default defineClassComponent(
  {
    components: BookCommentComponents,
  },
  () =>
    class {
      jointGoodsModel = jointGoodsModelProvider.inject()

      handleMoreClick = () => {
        navigateTo('BookCommentIndex', {
          goodsId: this.jointGoodsModel.value.goodsId,
        })
      }
    },
)
